import React from "react"

const BookingBadge = ({ variant, text }: { variant: string; text: string }): JSX.Element => (
  <span className={`text-uppercase badge bg-${variant}`} style={{ fontSize: "0.9rem" }}>
    {text}
  </span>
)

export default BookingBadge
